import React from 'react';

import { AUTH_SEND_MAIN_LINK } from '../../../constants/UrlConstants';
import { useExtra, usePageMessages } from '../../../hooks/selectors';
import { DangerouslyHtml } from '../../common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from '../../common/Layout/InfoPage/InfoPage';

const PromoUpgradeLimit = () => {
    const { upgradeLimitTitle, upgradeLimitSubTitle, continueButton, notNowButton } = usePageMessages();
    const { nextPageLink } = useExtra();
    return (
        <InfoPage
            iconName="id-card-thin"
            iconColor="purple"
            headerText={<DangerouslyHtml dangerouslyHtml={upgradeLimitTitle} />}
            secondaryText={<DangerouslyHtml dangerouslyHtml={upgradeLimitSubTitle} />}
            topButtonType="link"
            topButtonCaption={notNowButton}
            topButtonLink={AUTH_SEND_MAIN_LINK}
            primaryButtonCaption={continueButton}
            primaryButtonType="link"
            primaryButtonLink={nextPageLink}
        />
    );
};
export default PromoUpgradeLimit;
